import Card from '@tempcover/bolt-ui/card';
import { Carousel } from '@/components/ui/Carousel/Carousel';
import { StarRating } from '@/components/ui/StarRating/StarRating';

interface Review {
  review: {
    value: {
      name: string;
      data: {
        title: string;
        body: string;
        customerName: string;
        starRating: number;
      };
    };
  };
}

export const ReviewsCarousel: React.FC<{ _reviews: Review[] }> = (props) => {
  if (!props.hasOwnProperty('_reviews')) return null;

  return (
    <div>
      <Carousel>
        {props._reviews.map(({ review }) => {
          if (!review) return null;
          return (
            <Card key={review.value.name}>
              <blockquote className="flex flex-col items-center justify-center gap-2 text-center">
                <StarRating max={5} value={review.value.data.starRating} />
                <p className="text-dark font-medium">{review.value.data.title}</p>
                <p className="text-dark-200 mt-0">{review.value.data.body}</p>
                <p className="text-dark mt-0 mb-0 font-medium">{review.value.data.customerName}</p>
              </blockquote>
            </Card>
          );
        })}
      </Carousel>
    </div>
  );
};
